// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "service-2jnxW";
var _4 = "exclusivePlate-3vSxU";
var _5 = "service_active-2-O4D";
var _6 = "header-2bita";
var _7 = "header__text-2r7Nf";
var _8 = "list-20MzX";
var _9 = "list__item-1ZtbX";
var _a = "list__cities-1IgVg";
var _b = "list__services-3Daeg";
var _c = "icon-I4QdO";
var _d = "header__price-1VWJY";
var _e = "main-1ToFd";
var _f = "content-2B4yu";
var _10 = "buttons-2lyfw";
var _11 = "add-253ES";
export { _1 as "__esModule", _2 as "mobile", _3 as "service", _4 as "exclusivePlate", _5 as "service_active", _6 as "header", _7 as "header__text", _8 as "list", _9 as "list__item", _a as "list__cities", _b as "list__services", _c as "icon", _d as "header__price", _e as "main", _f as "content", _10 as "buttons", _11 as "add" }
export default { "__esModule": _1, "mobile": _2, "service": _3, "exclusivePlate": _4, "service_active": _5, "header": _6, "header__text": _7, "list": _8, "list__item": _9, "list__cities": _a, "list__services": _b, "icon": _c, "header__price": _d, "main": _e, "content": _f, "buttons": _10, "add": _11 }
